import request from '../../utils/request'

// 导入模板
export function importExcel (data) {
  return request.post('/business/questionnaire/importExcel', data, {
    trim: true
  })
}
